var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
// '#query-hooks' is imported by direct path: its barrel would close the context <-> query-hooks cycle (see CLAUDE.md).
import { useMemo } from 'react';
import { useFeatureFlags } from '#query-hooks/queries/general/useFeatureFlags';
import { FeatureFlagsContext } from './FeatureFlagContext';
export const FeatureFlagProvider = ({ children }) => {
    _react_refresh_temp_2();
    const { query: { data, isError, isPending }, } = useFeatureFlags();
    const contextValue = useMemo(() => ({
        isPending,
        isError,
        variants: data,
    }), [data, isError, isPending]);
    return (_jsx(FeatureFlagsContext.Provider, { value: contextValue, children: children }));
};
_react_refresh_temp_1 = FeatureFlagProvider;
$RefreshReg$(_react_refresh_temp_1, "FeatureFlagProvider");
_react_refresh_temp_2(FeatureFlagProvider, "vH0mdjXJ2+Z6gppDRsIW88g6yuk=", false, () => [useFeatureFlags]);
